import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { FormControl, InputLabel, MenuItem, SvgIconProps } from '@mui/material';
import { DesktopTooltip, ResponsiveSelect } from '@skoda/k2tools-app-components';
import * as React from 'react';
import ServicesContext from '../../../contexts/servicesContext';
import { ISelectOptionProps } from '../filterSelectBase';
import styles from './styles.scss';

type DropdownSelectProps = {
	onSubmit: (val: ISelectOptionProps, isValid: boolean) => void;
	isDisabled?: boolean;
	defaultValue: string;
	options: ISelectOptionProps[];
	tooltip?: string;
	filterControlClassName?: string;
	filterControlFilledClassName?: string;
	error?: string;
};

type DropdownSelectState = {
	selectedValue: ISelectOptionProps;
};

class DropdownSelect extends React.Component<DropdownSelectProps, DropdownSelectState> {
	static contextType = ServicesContext;
	context: React.ContextType<typeof ServicesContext>;

	constructor(props: DropdownSelectProps) {
		super(props);
		this.state = {
			selectedValue: null,
		};
	}

	componentWillReceiveProps(nextProps: DropdownSelectProps) {
		if (nextProps.options.length === 0) {
			this.setState({ selectedValue: null });
		} else {
			this.setState({ selectedValue: nextProps.options.find((x) => x.isSelected) });
		}
	}

	render() {
		return (
			<FormControl className={styles['form-control']}>
				<InputLabel className={styles['input-label']} disabled={this.props.isDisabled}>
					{this.props.defaultValue}
					{this.props.tooltip && (
						<DesktopTooltip<SvgIconProps>
							className={styles['desktop-tooltip']}
							AnchorComponent={InfoOutlinedIcon}
							AnchorComponentProps={{ color: 'primary' }}
						>
							<span>{this.props.tooltip}</span>
						</DesktopTooltip>
					)}
				</InputLabel>
				<ResponsiveSelect
					onChange={(event) => {
						const opt = this.props.options.find((element) => element.key === event.target.value);
						this.setState({ selectedValue: opt });
						this.props.onSubmit(opt, true);
					}}
					value={this.state.selectedValue?.key ?? ''}
					textCancel={this.context.resourceProvider.getText('Button_Cancel', 'Cancel')}
					textConfirm={this.context.resourceProvider.getText('Button_Confirm', 'Confirm')}
					disabled={this.props.isDisabled}
				>
					{this.props.options.map((option) => (
						<MenuItem className='menu-item-story' key={option.key} value={option.key}>
							{option.value}
						</MenuItem>
					))}
				</ResponsiveSelect>
			</FormControl>
		);
	}
}

export default DropdownSelect;
